import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { project } from "../../../system/types/project/project";
import { initialProject } from "../../../system/initial/project";
import { TextInput } from "../../FormElements/TextInput";
import { TextAreaInput } from "../../FormElements/TextareaInput";
import { LanguageSelector } from "../../FormElements/LanguageSelector";
import { language } from "../../../system/types/project/language";
import { useNavigate } from "react-router-dom";
import { ProjectApi } from "../../../system/api/ProjectApi";
import { dispatch } from "../../../App";
import { actions } from "../../../redux";
import { useTranslations } from "../../../hooks/useTranslations";

const EditProjectBase = () => {

    const { t } = useTranslations();

    const navigate = useNavigate();

    const [sessionToken, setSessionToken] = useState<string>('');
    const [sessionEmail, setSessionEmail] = useState<string>('');
    const [projectData, setProjectData] = useState<project>(initialProject);

    const [projectId, setProjectId] = useState<string>('');
    const [projectName, setProjectName] = useState<string>('');
    const [projectDescription, setProjectDescription] = useState<string>('');
    const [projectDefaultLanguage, setProjectDefaultLanguage] = useState<language>({
        name: '',
        isoCode: '',
        lang: ''
    });


    useSelector((state: RootState) => {

        if (state.activeUser.activeUserToken !== sessionToken) {
            setSessionToken(state.activeUser.activeUserToken);
        }

        if (state.activeUser.activeUserEmail !== sessionEmail) {
            setSessionEmail(state.activeUser.activeUserEmail);
        }

        if (state.project.projectId !== projectId) {
            setProjectId(state.project.projectId);
        }
        if (state.project.projectData !== projectData) {
            setProjectData(state.project.projectData);
        }

    });

    const changeProjectName = (input: string) => {
        setProjectName(input);
    };

    const changeProjectDescription = (input: string) => {
        setProjectDescription(input);
    };

    const changeDefaultLanguage = (language: language) => {
        setProjectDefaultLanguage(language);
    }

    const save = async () => {
        const newProjectData = {
            ...projectData,
            name: projectName,
            description: projectDescription,
            baseLanguage: projectDefaultLanguage,
        };

        if (newProjectData.accountId === '') {
            newProjectData.accountId = sessionEmail;
        }

        const api = new ProjectApi(sessionToken, sessionEmail);
        const result = await api.saveProject(projectId, newProjectData);

        if (result._id) {
            dispatch(actions.project.setData(result))
            navigate('/projects/' + result._id );
        }
    };

    const cancel = () => {
        if (projectData._id !== '') {
            navigate('/projects/' + projectData._id );
            return;
        }

        navigate('/projects');
    };

    useEffect(() => {
        setProjectName(projectData.name);
        setProjectDescription(projectData.description);
        setProjectDefaultLanguage(projectData.baseLanguage);
    }, [projectData]);

    return (<div className="container-float px-3 py-3">
        <div className="row mb-3 align-items-center">
            <div className="col"><h2>{projectName} &nbsp;</h2></div>
            <div className="col-auto"><button onClick={save} className="btn btn-outline-success">{t('common.save')}</button></div>
            <div className="col-auto"><button onClick={cancel} className="btn btn-outline-danger">{t('common.cancel')}</button></div>
        </div>
        <div className="row mb-3">
            <div className="col">
                <TextInput 
                    name="projectName" 
                    value={projectName} 
                    label={t('projects.projectname')}
                    onChange={changeProjectName}></TextInput>
            </div>
        </div> 
        <div className="row mb-3">
            <div className="col">
                <TextAreaInput 
                    name="projectDescription" 
                    value={projectDescription} 
                    label={t('projects.projectdescription')}
                    onChange={changeProjectDescription}></TextAreaInput>
            </div>
        </div>
        <div className="row mb-3">
            <div className="col">
                <LanguageSelector 
                    name="defaultLanguage" 
                    value={projectDefaultLanguage} 
                    label={t('projects.defaultlanguage')}
                    onChange={changeDefaultLanguage}></LanguageSelector>
            </div>
        </div>
    </div>);
};

export { EditProjectBase };
